<template>
    <div class="product-type-side">
        <el-menu active-text-color="#FBBA0E" background-color="#F2F2F2" class="el-menu-vertical-demo"
            :default-active="defaultActive" text-color="#333" @select="select" :collapse="collapse">
            <ProductTypeSubMenuItem :items="productTypes" :collapse="collapse"></ProductTypeSubMenuItem>
        </el-menu>
    </div>
</template>

<script lang="ts" setup>
import { Api } from '@/http/Api';
import { ResponseCode } from '@/http/ResponseCode';
import { Action } from '@/typeDefine/CommonTypes';
import { ProductTypes } from '@/typeDefine/EntityType';
import { GetProductTypesResponse } from '@/typeDefine/HttpResponseType';
import { UtilMethods } from '@/util/UtilMethods';
import { onMounted, ref, Ref, watch } from 'vue';
import ProductTypeSubMenuItem from './ProductTypeSubMenuItem.vue';
import { useRoute } from 'vue-router';

const props = defineProps<{
    isSelect?: boolean
}>()

const productTypes: Ref<ProductTypes[]> = ref([])

onMounted(() => {
    requestTypes()

    watchResize()
    window.addEventListener('resize', watchResize)
})

const defaultActive: Ref<string> = ref('')
const currentSelect: Ref<string> = ref('0')

//是否折叠
const collapse: Ref<boolean> = ref(false)

const route = useRoute()

const emit = defineEmits<{
    selectProductType: [string]
}>()


//获取页面参数
const getPageParams: Action<[string], string | null> = (paramName: string): string | null => {
    return typeof route.query[paramName] === 'string' ? route.query[paramName] : null
}

//监听窗口大小
const watchResize: Action = () => {
    const width: number = window.innerWidth

    if (width >= 1200) {
        collapse.value = false
    }

    else if (width < 1200) {
        collapse.value = true
    }
}

const requestTypes: Action = async () => {
    const response: GetProductTypesResponse = await Api.instance.getProductTypes()

    UtilMethods.showMessageToast(response, false)

    if (response.code === ResponseCode.OK) {
        productTypes.value = response.data.treeType

        if (props.isSelect) {
            defaultActive.value = getPageParams('typeId') ?? findFirstChild(productTypes.value)

            select(defaultActive.value)
        }
    }
}

//率先找到第一个子节点
const findFirstChild: Action<[ProductTypes[]], string> = (productTypes: ProductTypes[]) => {
    for (const child of productTypes) {
        if (child.children.length === 0) {
            return child.id + ''
        }

        return findFirstChild(child.children)
    }

    return ''
}

const select: Action<[string]> = (sel: string) => {

    if (currentSelect.value === sel) {
        return
    }

    currentSelect.value = sel
    emit('selectProductType', sel)
}

defineExpose<{
    requestTypes: Action
}>({
    requestTypes
})
</script>

<style lang="css" scoped>
.product-type-side {
    border-left: 6px solid #f2f2f2;
    padding-left: 10px;
}
</style>